import React from "react";
import Index from "./index";
import UserTable from "./UserTable";

const Users = () => {
    const { allUsers, loading, history, search, setSearch, onDelete, headerContent } = Index();
    return (
        <UserTable
            heading="All Users"
            allUsers={allUsers}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
            headerContent={headerContent}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(Users, comparisonFn);
